import ConfigManager from '@/config/ConfigManager';
import BzbsApi from '@/core/Http/BzbsApi.js';
import Account from '@/helper/AccountHelper';
import { map } from 'rxjs/operators';

export default {
    apiSearchHistory: function (params) {
        const token = Account.getToken();
        const url = ConfigManager.getApiUrl() + `/history/search_by`;
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },

    deleteSearchHistory: function (params) {
        const url = ConfigManager.getApiUrl() + `/history/clear`;
        return BzbsApi.connectBzbsPost(url, null , params).pipe(map((res) => {
            return res.data;
        }));
    },

    getSuggestion: function (params) {
        const url = ConfigManager.getApiUrl() + `/autocomplete/suggest`;
        return BzbsApi.connectBzbsGet(url, null , params).pipe(map((res) => {
            return res.data;
        }));
    }
}
